import PropTypes from 'prop-types';
import React from 'react';

function LinkButton({
  onClick = () => {},
  children = undefined,
  name=undefined,
}: {
  onClick?: VoidFunction,
  children?: React.ReactChild|React.ReactNode|string|null|undefined,
  name?:string|undefined
}) {
  
  return (
    <button name ={name} className="ifms-link-button" onClick={onClick}>
      {children}
    </button>
  );
}

LinkButton.defaultProps = {
  onClick: () => {},
};

LinkButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};


export default React.memo(LinkButton);
